"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PreviewLabel = _interopRequireDefault(require("./PreviewLabel"));

var _PreviewMedia = _interopRequireDefault(require("./PreviewMedia/"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class PreviewMediaArray extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderItem", (item, index) => {
      const id = this.props.id + "_" + index;
      const schema = this.props.schema.items || {};
      return _react.default.createElement(_PreviewMedia.default, {
        id: id,
        formData: item,
        schema: schema,
        key: index
      });
    });
  }

  render() {
    const _this$props = this.props,
          id = _this$props.id,
          schema = _this$props.schema,
          formData = _this$props.formData;

    if (formData && formData.length) {
      return _react.default.createElement("section", {
        className: "admin-preview__field  field--array"
      }, _react.default.createElement(_PreviewLabel.default, this.props), formData.map(this.renderItem));
    }

    return false;
  }

}

var _default = PreviewMediaArray;
exports.default = _default;
module.exports = exports.default;